(function () {
  'use strict';

  angular.module('app').component('providerListSearch', providerListSearch());

  function providerListSearch() {
    return {
      bindings: {
        providerSelected: '=',
        onShowProvider: '&',
        onProviderSelected: '&',
      },
      controller: ProviderListSearchComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/providers/components/provider-list-search/provider-list-search.component.html',
    };
  }

  ProviderListSearchComponent.$inject = [
    'UtilService',
    'AbilityService',
    'ProviderService',
    'ProviderTypeService',
  ];

  function ProviderListSearchComponent(
    UtilService,
    AbilityService,
    ProviderService,
    ProviderTypeService
  ) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_provider_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = ProviderService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showProvider = showProvider;
    vm.selectProvider = selectProvider;

    // Initializers
    fetchResult();
    // getProviderTypes();

    function fetchResult() {
      vm.loadingProviders = true;
      ProviderService.getProviders(vm.filterCriteria).then(function (data) {
        vm.providers = data.items;
        vm.meta = data.meta;

        vm.loadingProviders = false;
      });
    }

    function getProviderTypes() {
      ProviderTypeService.getProviderTypes({ get: 'active', skip_check_role: true }).then(function (
        data
      ) {
        vm.providerTypes = data.items;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.filterCriteria = ProviderService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showProvider(provider, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowProvider({ item: provider, mode: mode });
    }

    function selectProvider(provider) {
      vm.onProviderSelected({ item: provider });
    }
  }
})();
